import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"menu\"><path class=\"cls-1\" d=\"M101.34 136a6.5 6.5 0 0 1 6.5-6.5h184.32a6.5 6.5 0 0 1 0 13H107.84a6.5 6.5 0 0 1-6.5-6.5zm190.82 57.5H107.84a6.5 6.5 0 0 0 0 13h184.32a6.5 6.5 0 0 0 0-13zm0 64H107.84a6.5 6.5 0 0 0 0 13h184.32a6.5 6.5 0 0 0 0-13z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol